var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.save}},[_c('i',{staticClass:"fa fa-floppy-o"})])
}
var staticRenderFns = []

export { render, staticRenderFns }